import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[modal-host]',
    standalone: false
})
export class SGCModalDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
